import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarHeadingTitle from "../../SidebarHeadingTitle";
import ApplicationList from "./ApplicationList";

import {SidebarContext} from "../../../../../SidebarContext";

function ApplicationMenuContent(props) {
    const {isMobile} = useContext(SidebarContext);

    return (
        <div style={{...!isMobile && {padding: '12px'}}}>
            <SidebarHeadingTitle>
                <FormattedMessage id='sidebar.application.title' />
            </SidebarHeadingTitle>
            <ApplicationList />
        </div>
    );
}

export default ApplicationMenuContent;
